import {Component, Input, OnInit} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {Step4} from '../../../../shared/models/component-messages/diveIN/step4';
import {ArrayPopTools} from '../../../../shared/services/array-pop-tools';
import {Lot} from '../models/Lot';
import {TypeLotsDivers} from '../models/TypeLotsDivers';

@Component({
  selector: 'app-type-lots-divers',
  templateUrl: './type-lots-divers.component.html'
})
export class TypeLotsDiversComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'TypeLotsDivers';
  @Input() parentForm: FormGroup;
  @Input() lots: TypeLotsDivers;
  @Input() disabled: boolean;

  public step4 = new Step4();

  constructor() {
  }

  public ngOnInit() {
    if (this.lots == undefined) {
      this.lots = new TypeLotsDivers;
    }
    if (!this.lots.lot ||
      this.disabled && this.lots.lot.length > 0) {
      this.lots.lot = [];
    }
    if (!this.disabled && this.lots.lot.length === 0) {
      this.addlot();
    }
  }

  addlot() {
    this.lots?.lot.push(new Lot());
  }

  removelot(i) {
    ArrayPopTools.pop(this.lots?.lot, i, this.parentForm, this.getUid());
  }

  public getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }

  getStepId() {
    return this.uid.substring(0, this.uid.indexOf("SepSep"));
  }

}

